import { FaIcon } from '@y42/core/icon';

export const encFileIcon: FaIcon = 'key';
export const metadataJsonIcon: FaIcon = 'stream';
export const anyJsonIcon: FaIcon = 'cogs';
export const sqlFileIcon: FaIcon = 'database';
export const testsFileIcon: FaIcon = 'flask-vial';
export const plusIcon: FaIcon = 'plus';
